import React,{ useState, useEffect } from "react";
import { Divider, Steps } from 'antd';

function OrderCompletionSteps( { currentStep, paymentReceived, cartHasItems } ) {
    const [firstNameValidSuffix, setFirstNameValidSuffix] = useState(<></>);
    
    return ( 
        <div className={`order-completion-steps ${( paymentReceived || !cartHasItems )? '' : 'active'}`} >
            <Steps
                progressDot
                size={'small'}
                current={ currentStep }
                items={[
                    {
                        title: 'Contact information',
                        description: '',
                    },
                    {
                        title: 'Service address',
                        description: '',
                    },
                    {
                        title: 'Activation date',
                        description: '',
                    },
                    {
                        title: 'Payment details',
                        description: '',
                    }
                ]}
            />
        </div>
    )
}

export default OrderCompletionSteps